import { useNavigate, useParams } from "react-router-dom";
import AppBar from "../../../components/atoms/appbar";
import Button from "../../../components/atoms/button";
import { vw } from "../../../lib/utils/responsiveUtils";
import { useQuery } from "@tanstack/react-query";
import { useGetResveDetail } from "../../../@apis/hooks/useResve";
import { formatKoDayDate, timeStamp } from "../../../lib/utils/dateUtils";
import { staticURL } from "../../../lib/utils/imageUtils";
import { cn } from "../../../lib/utils/cn";

export default function ReservationHistoryDetail() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: resveDetailResponse } = useQuery({
    ...useGetResveDetail(id!),
  });
  const resveDetailInfo = resveDetailResponse?.data?.resveInfo;
  
  if (!resveDetailInfo) return <p>로딩중...</p>;
  
  const { golfParkName, golfCourseName, golfParkImageUrl, golfParkAddress, baseDate, startTime, resveTimeMemberList, isCompleteRound } = resveDetailInfo;
  const myMember = resveDetailInfo.resveTimeMemberList?.[0];

  const Z_CLASSES = ["z-40", "z-30", "z-20", "z-10"] as const;

  function openTmap(name: string, address: string) {
    const keyword = encodeURIComponent(name || address);
    window.location.href = `tmap://search?name=${keyword}`;
  }
  function openKakaoMap(name: string, address: string) {
    const keyword = encodeURIComponent(name || address);
    window.location.href = `kakaomap://search?q=${keyword}`;
  }

  const formattedCardNumber = (cardNo: string) => {
    if (typeof cardNo !== 'string' || cardNo.length !== 16) {
      return null;
    }

    const chunks = cardNo.match(/.{1,4}/g);
    if (!chunks) {
      return null;
    }
    const formatted = chunks.join("-")
    return formatted.slice(0, -1) + "*"
  }

  return (
    <div className="flex flex-col min-h-screen">
      <AppBar backButton />

      <div className="px-[15px] mb-[100px]">
        {/* 예약 상태 */}
        <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center justify-between" style={{ height: vw(95) }}>
          <div className="flex flex-col justify-center gap-[14px]">
            <p className="font-bold text-[#222]" style={{ fontSize: vw(20) }}>예약 완료</p>
            <p className="font-[500] text-[#888]" style={{ fontSize: vw(12) }}>
              {timeStamp(myMember?.bookingDate)}
            </p>
          </div>
          {isCompleteRound && (
            <div className="rounded-full bg-[#e6e6e6] flex justify-center items-center" style={{ width: vw(55), height: vw(55) }}>
              <img style={{ width: vw(28), height: vw(32) }} src="/icons/ic-stamp.webp" alt="완료" />
            </div>
          )}
        </div>

        {/* 골프장 정보 */}
        <div className="mt-[15px]">
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(60) }}>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(16) }}>
              {formatKoDayDate(baseDate)} {startTime}
            </p>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px" }} />

          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex flex-col justify-center" style={{ height: vw(isCompleteRound ? 132 : 174) }}>
            <div className="flex items-center gap-[19px]">
              <img className="rounded-[10px] object-cover bg-white" style={{ width: vw(83), height: vw(83) }} src={golfParkImageUrl ? staticURL(golfParkImageUrl) : "/images/img-login-logo.webp"} alt="골프장 이미지" />
              <div className="flex flex-col justify-center">
                <p className="text-[#222] font-bold" style={{ fontSize: vw(20) }}>{golfParkName}</p>
                <div className="flex items-start gap-[5px] mt-[13px]">
                  <img src="/icons/ic-place-gray.webp" alt="위치 아이콘" style={{ width: vw(14), height: vw(14) }} />
                  <p className="text-[#888] font-[500] leading-[1.5]" style={{ fontSize: vw(12) }}>{golfParkAddress}</p>
                </div>
              </div>
            </div>

            {!isCompleteRound && (
              <Button
                type="button"
                className="mt-[15px] font-[500] rounded-[17.5px]"
                style={{ height: vw(35), fontSize: vw(12) }}
                variant="white"
                label="주소 복사"
                onClick={() => {
                  const t = document.createElement("textarea");
                  t.value = golfParkAddress;
                  document.body.appendChild(t);
                  t.select();
                  document.execCommand("copy");
                  document.body.removeChild(t);
                  alert("주소를 복사했습니다.");
                }}
              />
            )}
          </div>
        </div>

        {/* 내비 버튼 */}
        {!isCompleteRound && (
          <div className="mt-[10px] flex items-center gap-[10px]">
            <Button type="button" className="font-[500] rounded-[25px] flex items-center justify-center gap-[11px]" style={{ width: vw(167), height: vw(50), fontSize: vw(14) }} variant="white"
              onClick={() => openTmap(golfParkName, golfParkAddress)}
            >
              <img src="/icons/ic-tmap.webp" alt="티맵" className="w-[20px] h-[20px]" />티맵
            </Button>
            <Button type="button" className="font-[500] rounded-[25px] flex items-center justify-center gap-[11px]" style={{ width: vw(167), height: vw(50), fontSize: vw(14) }} variant="white"
              onClick={() => openKakaoMap(golfParkName, golfParkAddress)}
            >
              <img src="/icons/ic-kakao.webp" alt="카카오" className="w-[20px] h-[20px]" />카카오맵
            </Button>
          </div>
        )}

        {/* 코스 + 참가자 */}
        <div className="mt-[15px] rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center justify-between" style={{ height: vw(80) }}>
          <p className="text-[#222] font-bold" style={{ fontSize: vw(20) }}>{golfCourseName}</p>
          <div className="flex items-center -space-x-[10px]">
            {[0, 1, 2, 3].map((_, i) => {
              const m = resveTimeMemberList[i];
              const bg = m?.sex === undefined ? "#e6e6e6"  : m.sex === null ? "#e6e6e6"  : m.sex === 0 ? "#f95e80" : "#25a1d5";
              const icon =
                m?.sex === undefined
                  ? "/icons/ic-rest.webp"
                  : m.sex === null
                  ? "/icons/ic-gender.webp"
                  : m.sex === 0
                  ? "/icons/ic-female.webp"
                  : "/icons/ic-male.webp";

              const isPayer = m && m.groupUuid === (myMember?.groupUuid ?? null);

              return (
                <div key={i} className={`${Z_CLASSES[i]} rounded-full flex justify-center items-center border-2 ${isPayer ? "border-[#222]" : "border-white"}`} style={{ width: vw(40), height: vw(40), backgroundColor: bg }}>
                  <img src={icon} style={{ width: vw(26), height: vw(24) }} alt="플레이어" />
                </div>
              );
            })}
          </div>
        </div>

        {/* 결제 정보 */}
        <div className="mt-[15px]">
          <div className="mt-[15px] rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center justify-between" style={{ height: vw(60) }}>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(16) }}>라운드 비용</p>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(20) }}>{myMember?.payMemberNum}인 {(myMember?.amt ?? "").toLocaleString()}원</p>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px", }} />

          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex flex-col justify-center" style={{ height: vw(106) }}>
            <div className="flex items-center justify-between">
              <p className="text-[#222] font-bold" style={{ fontSize: vw(16) }}>결제 정보</p>
              <p className="text-[#e5002b] font-bold" style={{ fontSize: vw(20) }}>{(myMember?.amt ?? "").toLocaleString()}원</p>
            </div>

            <div className="mt-[15px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
              <div className="flex justify-between">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 수단</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{myMember?.payMethod === "CASH" ? "현장결제" : myMember?.payMethod === "CARD" ? `${myMember?.cardName ?? ""}카드 ${formattedCardNumber(myMember?.cardNo || "")}` : ""}</p>
              </div>
              <div className="flex justify-between mt-[6px]">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 금액</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{(myMember?.amt ?? "").toLocaleString()}원</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 하단 버튼 */}
      <div className={cn("bg-white p-[15px] fixed max-w-[440px] w-full bottom-0 flex-row-between z-50")}>
        <Button type="button" className="w-full font-bold h-[50px]" variant="black" label="예약 취소" onClick={() => navigate(`/setting/reservation-history/${id}/cancel`)} />
      </div>
    </div>
  );
}
